import { AddressDTO } from '../generated'
import { CountryCodes } from '../types'

export function getCountryNameByCode(code: CountryCodes, translationFunc: (key: CountryTranslationKey) => string) {
    return translationFunc(('countries.' + code) as any)
}

type CountryTranslationKey = `countries.${CountryCodes}`
export function formatAddress(address: AddressDTO, translationFunc: (key: CountryTranslationKey) => string) {
    return `${address.companyName}, ${address.firstName || address.lastName ? `${address.firstName} ${address.lastName},` : ''} ${address.street} ${
        address.houseNumber
    }, ${address.postalCode} ${address.city}, ${translationFunc(('countries.' + address.country) as any) || address.country}`
}
